import Vue from 'vue'
import VueRouter from 'vue-router'
import Menu from '../components/Menu.vue'
import HygienistsSingle from '../components/HygienistsSingle.vue'
import HygienistsDouble from '../components/HygienistsDouble.vue'
import POPSingle from '../components/POPSingle.vue'
import POPDouble from '../components/POPDouble.vue'
import POPMenu from '../components/POPMenu.vue'
import DentistMCD from '../components/DentistMCD.vue'
import DentistAssociate from '../components/DentistAssociate.vue'
import PracticeMCD from '../components/PracticeMCD.vue'
import PracticeAssociate from '../components/PracticeAssociate.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Menu',
    component: Menu
  },
  {
    path: '/HygienistsSingle',
    name: 'HygienistsSingle',
    component: HygienistsSingle
  },
  {
    path: '/HygienistsDouble',
    name: 'HygienistsDouble',
    component: HygienistsDouble
  },
  {
    path: '/POPSingle',
    name: 'POPSingle',
    component: POPSingle
  },
  {
    path: '/POPDouble',
    name: 'POPDouble',
    component: POPDouble
  },
  {
    path: '/DentistMCD',
    name: 'DentistMCD',
    component: DentistMCD
  },
  {
    path: '/DentistAssociate',
    name: 'DentistAssociate',
    component: DentistAssociate
  },
  {
    path: '/PracticeMCD',
    name: 'PracticeMCD',
    component: PracticeMCD
  },
  {
    path: '/PracticeAssociate',
    name: 'PracticeAssociate',
    component: PracticeAssociate
  },
  {
    path: '/POPMenu',
    name: 'POPMenu',
    component: POPMenu
  },
  {
    path: '/*',
    component: 404
    },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
